import React from 'react';
import { AlertTriangle, X } from 'lucide-react';

interface AlterarSegmentacaoModalProps {
  isOpen: boolean;
  onClose: () => void;
  onConfirm: () => void;
  tipoAtual: string;
}

export const AlterarSegmentacaoModal: React.FC<AlterarSegmentacaoModalProps> = ({
  isOpen,
  onClose,
  onConfirm,
  tipoAtual,
}) => {
  if (!isOpen) return null;

  return (
    <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50 p-4" style={{zIndex: 20000}}>
      <div className="bg-white rounded-2xl shadow-2xl max-w-md w-full">
        <div className="p-6">
          <div className="flex items-start space-x-4">
            <div className="flex-shrink-0">
              <div className="p-3 bg-red-100 rounded-full">
                <AlertTriangle className="h-6 w-6 text-red-600" />
              </div>
            </div>

            <div className="flex-1">
              <h3 className="text-lg font-semibold text-gray-900 mb-2">
                Alterar Tipo de Segmentação
              </h3>
              <p className="text-sm text-gray-600 mb-3">
                Caso você mude a segmentação, todas as informações configuradas para a segmentação atual <span className="font-semibold">({tipoAtual})</span> serão perdidas.
              </p>
              <p className="text-sm text-red-600 font-medium">
                Deseja continuar?
              </p>
            </div>

            <button
              onClick={onClose}
              className="flex-shrink-0 p-1 hover:bg-gray-100 rounded-lg transition-colors"
            >
              <X className="h-5 w-5 text-gray-500" />
            </button>
          </div>
        </div>

        <div className="flex items-center justify-end space-x-3 p-6 border-t border-gray-200 bg-gray-50 rounded-b-2xl">
          <button
            onClick={onClose}
            className="px-4 py-2 border border-gray-300 text-gray-700 rounded-lg hover:bg-gray-50 transition-colors"
          >
            Cancelar
          </button>
          <button
            onClick={onConfirm}
            className="px-4 py-2 bg-red-600 text-white rounded-lg hover:bg-red-700 transition-colors font-medium"
          >
            Sim, alterar segmentação
          </button>
        </div>
      </div>
    </div>
  );
};
